<template>
  <div>
    <div class="border-dotted border-2 overflow-auto w-full" :style="`height: ${height};`" @click="openDialog">
      <template v-if="selectedMembers && selectedMembers.length > 0">
        <el-tag
          v-for="(item, index) in selectedMembers"
          :key="index"
          disable-transitions
        >
          <i :class="[{ 'el-icon-user-solid text-red-500' : (item.type === 'user'), 'bi-diagram-3-fill text-yellow-500' : (item.type === 'department'), 'bi-person-workspace text-blue-500' : (item.type === 'role'), 'bi-person-lines-fill text-green-500' : (item.type === 'dynamic')}, 'pr-1 text-lg']" />
          <span class="text-sm text-black">{{ item.name }}</span>
        </el-tag>
      </template>
      <div v-else class="grid  place-items-center h-full"><i class="el-icon-plus text-gray-400 text-sm">添加</i></div>
    </div>
    <el-dialog class="pub_dialog" :append-to-body="modalAppendToBody" :visible.sync="dialogVisible" title="部门成员列表" width="60%">
      <member-list v-if="dialogVisible" v-model="members" :single="single" :tabs="tabs" @cancel="dialogVisible=false" @input="onConfirm" />
    </el-dialog>
  </div>
</template>

<script>

import MemberList from './MemberList'
import _ from 'lodash'

export default {
  components: {
    MemberList,
  },
  props: {
    height: {
      type: String,
      default: '80px',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    modalAppendToBody: {//解决嵌套 Dialog 遮罩层级
      type: Boolean,
      default: false,
    },
    value: {
      type: [Array, String, Object],
      default: () => [] ,
    },
    data: {
      type: Array,
      default: () => [] ,
    },
    single: {
      type: Boolean,
      default: false,
    },
    tabs: {
      type: Array,
      default: () => [
        'department',//组织架构
        'role',//角色
        'user',//成员
        // 'dynamic',//动态负责人
      ],
    },
  },
  data() {
    return {
      dialogVisible: false,
      selectedMembers: this.data,
      members: [],
    }
  },
  watch: {
    // selectedMembers(val) {
    //   console.log('selectedMembers changed', val)
    // },
    // members(val) {
    //   console.log('members changed', val)
    // },
  },
  created() {
    console.log('member list pane', this.value, this.data, this.readonly)
    if (this.data.length === 0 && this.value) {
      this.value.map((item) => {
        // console.log('value map ', item)
        // if (item.indexOf('dynamic_') === 0) {
        //   console.log('dynnnnnnn')
        //   this.data.push({
        //     type: 'dynamic',
        //     id: 1,
        //     name: '上级部门',
        //   })
        //   this.selectedMembers = this.data
        // }
      })
    }
  },
  methods: {
    openDialog() {
      if (this.readonly) {
        return
      }
      this.members = _.cloneDeep(this.selectedMembers)
      this.dialogVisible = true
    },
    onConfirm() {
      console.log('member list pane onConfirm', this.members)
      this.selectedMembers = _.cloneDeep(this.members)
      var res = this.selectedMembers.map(item => {

        return item.type + '_' + item.id
      })
      if (this.single) {
        res = res.length > 0 ? res[0] : ''
      }
      this.$emit('input', res)
      this.dialogVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.el-tag {
  margin-left: 5px;
  margin-top: 5px;
}

.member-list {
  ::v-deep .el-tabs {
    height: 100%;

    .el-tabs__item.is-top:nth-child(2) {
      padding-left: 20px;
    }

    .el-tabs__header {
      margin-bottom: 0;
    }

    .el-tabs__content {
      height: calc(100% - 39px);

      .el-tab-pane {
        height: 100%;
      }
    }

  }
}

</style>
